export default __webpack_public_path__ + "static/media/wp-scheduled-posts-logo.1b8c5b2f.png";